import {connect} from 'react-redux';
import SaveAsDialog from './SaveAsDialog';

export default connect(
    state => {
        return {
            folders: state.menu.roots
        }
    }
)(SaveAsDialog);